import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IoSearch } from 'react-icons/io5';

export const NoSearchResults: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      // Fill the card's free height so the message sits centred, not at the top.
      flex: 1,
      py: 3,
      px: 1,
      gap: 1,
    }}
  >
    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: '50%',
        bgcolor: '#f5f5f7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IoSearch size={22} color="#9aa0a6" />
    </Box>
    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e' }}>No matches found</Typography>
    <Typography sx={{ fontSize: 12, color: '#888', lineHeight: 1.4 }}>
      Try a different name or clear your search.
    </Typography>
  </Box>
);
